import type { Feature } from '@luna/gatekeeper';

export const temporaryLimits: Feature = {
    enabled: true,
    _description:
        'Enables temporary limits feature display on the card features page and supplementary card settings page',
};
